<template>
    <div class="Results" :class="{ flash }">
        <div class="side side--left">
            <div class="textBox">
                <div class="label" v-html="$t('labelA')" />
                <div v-if="testStatsForA" class="score">
                    {{ testStatsForA.correctCount }} {{ $t('general.of') }} {{ testStatsForA.totalCount }}
                </div>
            </div>

            <CircularLayout class="progressAnchor" :steps="20" :start="0" :end="-180 + 5">
                <div slot-scope="{ index }" class="line" :class="{ active: index < left }" :data-index="index" />
            </CircularLayout>
        </div>

        <div class="side side--right">
            <div class="textBox">
                <div class="label" v-html="$t('labelB')" />
                <div v-if="testStatsForB" class="score">
                    {{ testStatsForB.correctCount }} {{ $t('general.of') }} {{ testStatsForB.totalCount }}
                </div>
            </div>

            <CircularLayout class="progressAnchor" :steps="20" :start="0" :end="180 - 5">
                <div slot-scope="{ index }" class="line" :class="{ active: index < right }" :data-index="index" />
            </CircularLayout>
        </div>
    </div>
</template>

<translations>
  labelA: 'Working<br>Memory'
  labelA_no: 'Arbeids-<br>hukommelse'
  labelB: 'Creative<br>Memory'
  labelB_no: 'Kreativ<br>hukommelse'
</translations>

<script>
import CircularLayout from './CircularLayout';

const LINECOUNT = 20;

export default {
    components: { CircularLayout },
    computed: {
        testStatsForA() {
            return this.$store.state.moduleMemogenius.settings.memoryOnboardingTestA;
            // return {
            //   correctCount: 5,
            //   totalCount: 10
            // }
        },
        testStatsForB() {
            return this.$store.state.moduleMemogenius.settings.memoryOnboardingTestB;
            // return {
            //   correctCount: 10,
            //   totalCount: 10
            // }
        },
        left() {
            return this.testStatsForA
                ? (this.testStatsForA.correctCount / this.testStatsForA.totalCount) * LINECOUNT
                : 0;
        },
        right() {
            return this.testStatsForB
                ? (this.testStatsForB.correctCount / this.testStatsForB.totalCount) * LINECOUNT
                : 0;
        },
        flash() {
            return !this.testStatsForA && !this.testStatsForB;
        }
    },
    mounted() {
        let timeNeededForAnimation = Math.max(this.left, this.right) * 200 + 2000;
        if (this.flash) {
            timeNeededForAnimation = LINECOUNT * 100 + 1500;
        }
        setTimeout(() => {
            this.$emit('animation-completed');
        }, timeNeededForAnimation);
    }
};
</script>

<style lang="scss" scoped>
$colorLeft: #2ea79e;
$colorRight: #cf8426;

.Results {
    display: flex;

    &.flash {
        .side--right {
            .line {
                animation: flash-right 1s;
                @keyframes flash-right {
                    0% {
                        background-color: rgba($colorLeft, 0.2);
                        box-shadow: none;
                    }
                    50% {
                        background-color: $colorRight;
                    }
                    100% {
                        background-color: rgba($colorLeft, 0.2);
                        box-shadow: none;
                    }
                }
            }
        }
        .side--left {
            .line {
                animation: flash-left 1s;
                @keyframes flash-left {
                    0% {
                        background-color: rgba($colorLeft, 0.2);
                        box-shadow: none;
                    }
                    50% {
                        background-color: $colorLeft;
                    }
                    100% {
                        background-color: rgba($colorLeft, 0.2);
                        box-shadow: none;
                    }
                }
            }
        }
        .line {
            @for $i from 0 through 20 {
                &[data-index='#{$i}'] {
                    animation-delay: $i * 0.1s + 0.5s;
                }
            }
        }
    }
}
.side {
    flex: 1;
    height: 24em;
    position: relative;
    display: flex;
    align-items: center;

    .progressAnchor {
        position: absolute;
        top: 50%;
    }
}
.side--left {
    justify-content: flex-end;
    color: $colorLeft;
    .CircularLayout {
        right: 3em;
    }
    .line {
        background-color: $colorLeft;
        box-shadow: 0 0 0.5em 0.05em rgba($colorLeft, 0.7);
    }
    .label {
        text-shadow: 0 0 0.2em rgba($colorLeft, 0.7);
    }
}
.side--right {
    justify-content: flex-start;
    color: $colorRight;
    .CircularLayout {
        left: 3em;
    }
    .line {
        background-color: $colorRight;
        box-shadow: 0 0 0.5em 0.05em rgba($colorRight, 0.7);
    }
    .label {
        text-shadow: 0 0 0.2em rgba($colorRight, 0.7);
    }
}
.textBox {
    position: relative;
    width: 10em;
    text-align: center;
}
.label {
    font-size: 150%;
    text-shadow: 0 0 1em white;
}
.score {
    position: absolute;
    bottom: -2em;
    text-align: center;
    width: 100%;
    font-weight: 600;
    color: rgba(white, 0.5);
    animation: appear 1s;
    animation-delay: 0.5s;
    animation-fill-mode: backwards;
    transform-origin: top center;

    @keyframes appear {
        0% {
            transform: scale(2.5);
            opacity: 0;
        }
        100% {
        }
    }
}

.line {
    position: relative;
    top: 9em;
    left: -1px;
    width: 2px;
    height: 5em;
    &:not(.active) {
        box-shadow: none;
        background-color: rgba($colorLeft, 0.2);
    }

    &.active {
        animation: activate 1s;
        animation-fill-mode: backwards;

        @keyframes activate {
            0% {
                background-color: rgba($colorLeft, 0.2);
                box-shadow: none;
            }
            100% {
                background-color: '';
            }
        }
    }

    @for $i from 0 through 20 {
        &[data-index='#{$i}'] {
            animation-delay: $i * 0.2s + 2s;
        }
    }
}

@include media('>=mobile') {
}

@include media('<mobile') {
    .side--left {
        .CircularLayout {
            right: 2em;
        }
    }
    .side--right {
        .CircularLayout {
            left: 2em;
        }
    }
    .textBox {
        width: 8em;
    }
    .label {
        font-size: 110%;
    }
    .score {
        font-size: 90%;
    }
    .line {
        position: relative;
        top: 6em;
        height: 3em;
    }
}
</style>
